// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_21-1";
export var movingGradient = "_21-4";
export var movingGradientBlock = "_21-2";
export var skeleton = "_21-0";
export var skeletonText = "_21-3";